import styled, { css } from 'styled-components';
import { MainButton } from 'globalStyles/Buttons';
import { MarkdownContainer } from 'globalStyles/CardDetails';
import { WrapperProps, CaseInputProps } from './types';

export const Wrapper = styled.div`
  object-fit: cover;
  flex-grow: 1;
  width: 100%;
  @media (max-width: 724px) {
    background-image: url('${(props: WrapperProps) =>
      props.backgroundImage || '/assets/icons/bg-case-opening-white.png'}');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export const TitleStyles = css`
  margin: 26px 0;
  max-width: 304px;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: normal;
  color: ${({ theme }) => theme.primaryColor};
`;

export const DescriptionStyles = css`
  margin: 20px 2px 24px 0;
  max-width: 304px;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${({ theme }) => theme.historyProviderColor};
`;

export const FollowMyCaseTitle = styled.p`
  margin: 58px 0 7px 2px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.historyProviderColor};
`;

export const InvalidCaseNumber = styled.p`
  margin: 5px 100.8px 0 0;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: ${({ theme }) => theme.errorAlertBorderColor};
`;

export const Button = styled(MainButton)`
  line-height: 1.29;
  letter-spacing: 1.17px;
  font-size: 14px;
  width: 100%;
  border-radius: 0;
  border-bottom: solid 2px ${({ theme }) => theme.onBackgroundColor};
`;

export const InputContainer = styled.div`
  width: 304px;
  display: flex;
`;

export const CaseInput = styled.input`
  flex-grow: 1;
  padding-left: 16px;
  height: 48px;
  ${(props: CaseInputProps) => props.error && 'border: solid 1px #c91432;'}
  :focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.primaryColor};
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) =>
    theme.primaryButtonColor || theme.primaryColor};
  width: 48px;
  height: 48px;
`;

export const MarkdownContainerCaseOpening = styled(MarkdownContainer)`
  h1 {
    ${TitleStyles}
  }

  p {
    ${DescriptionStyles}
  }
`;
